<template>
  <section class="conta">
    <div class="container">
      <h2>
        Informações Pessoais
        <span> Essas informações so serão acessadas por você </span>
      </h2>

      <label> Nome Completo: </label>
      <input
        v-model="account.fullName"
        type="text"
        placeholder="Nome Completo"
        :disabled="isDisable >= 1"
      />
      <label> RG: </label>
      <input
        v-model="account.rg"
        type="RG"
        placeholder="************"
        :disabled="isDisable >= 1"
      />
      <label> CPF: </label>
      <input
        v-model="account.cpf"
        type="number"
        placeholder="***.***.***. - **"
        :disabled="isDisable >= 1"
      />
      <label> CEP: </label>
      <input
        v-model="account.cep"
        type="number"
        placeholder="*****-***"
        :disabled="isDisable >= 1"
        @blur="viaCepSearch()"
      />
      <label> Logradouro: </label>
      <input
        v-model="account.logradouro"
        type="text"
        placeholder="Logradouro"
        :disabled="isDisable >= 1"
      />
      <label> Bairro: </label>
      <input
        v-model="account.bairro"
        type="text"
        placeholder="Bairro"
        :disabled="isDisable >= 1"
      />
      <label> Cidade: </label>
      <input
        v-model="account.cidade"
        type="text"
        placeholder="Cidade"
        :disabled="isDisable >= 1"
      />
      <label> Numero da Casa: </label>
      <input
        v-model="account.numero_casa"
        type="number"
        placeholder="Numero"
        :disabled="isDisable >= 1"
      />
      <label> Complemento: </label>
      <input
        v-model="account.complemento"
        type="text"
        placeholder="Complemento"
        :disabled="isDisable >= 1"
      />
      <label> Estado: </label>
      <input
        v-model="account.estado"
        type="text"
        placeholder="Estado"
        :disabled="isDisable >= 1"
      />
      <label> Numero de Whatsapp: </label>
      <input
        v-model="account.numero_whats"
        type="text"
        placeholder="Numero de Whatsapp"
        :disabled="isDisable >= 1"
      />

      <div style="display:flex">
        <button @click="salvar()">
          Salvar
        </button>

        <button
          style="background-color: #67C23A; margin-left:10px"
          @click="editInput"
        >
          Editar
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import TeacherService from '../../../../../service/TeacherService/TeacherService.js';

const app = new TeacherService();

const id = localStorage.getItem('user');

export default {
  name: 'Account',
  data() {
    return {
      isDisable: 999,
      account: {
        id: '',
        fullName: '',
        rg: '',
        cep: '',
        cpf: '',
        logradouro: '',
        cidade: '',
        estado: '',
        bairro: '',
        numero_casa: '',
        complemento: '',
        numero_whats: '',
      },
    };
  },

  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      const { data } = await axios.get(`${process.env.VUE_APP_API}/user/${id}`);
      delete data.courses;
      delete data.about;
      delete data.email;
      delete data.firstName;
      delete data.lastName;
      delete data.location;
      delete data.phone;
      delete data.accountBank;
      delete data.trailer_about;
      delete data.createdAt;
      delete data.role;
      delete data.status;
      delete data.updatedAt;
      delete data.comments;
      delete data.slug;
      this.account = data;
    },
    async viaCepSearch() {
      let cep = this.account.cep;
      await axios.get(`http://viacep.com.br/ws/${cep}/json/`).then(data => {
        this.account.logradouro = data.data.logradouro;
        this.account.cidade = data.data.localidade;
        this.account.estado = data.data.uf;
        this.account.bairro = data.data.bairro;
      });
    },
    editInput() {
      if (this.isDisable > 0) {
        this.isDisable = 0;
      } else {
        this.isDisable = 999;
      }
    },
    async salvar() {
      console.log(id);
      this.account.id = id;
      console.log(this.account);

      await app.update(this.account);
    },
  },
};
</script>

<style lang="scss" scoped>
.conta {
  background: #fff;

  .container {
    max-width: 910px;
    margin: auto;
    padding: 26px 30px 24px 24px;

    * {
      display: block;
    }

    h2 {
      color: #3a3b3f;
      font-weight: 700;
      font-size: 1rem;
      // margin-bottom: 50px;

      span {
        display: inline-block;
        margin-left: 16px;
        color: #66788a;
        font-size: 0.875rem;
        font-weight: 400;
      }
    }

    label {
      margin-bottom: 10px;
      color: #66788a;
      font-size: 1.35rem;
    }

    input {
      width: 100%;
      margin-bottom: 24px;
      font-size: 16px;
      padding: 16px;
      border: 1px solid rgba(102, 120, 138, 0.3);
      border-radius: 4px;
    }

    span {
      color: #3a3b3f;
      font-weight: 700;
      margin-bottom: 24px;
    }

    input::placeholder {
      color: #dadada;
    }

    a {
      color: #1665d8;
      margin-bottom: 24px;
    }

    button {
      color: white;
      background: #1d43ff;
      border: none;
      font-size: 0.875;
      padding: 12px 48px;
      border-radius: 4px;
      font-weight: 700;
    }
  }
}

@media (max-width: 768px) {
  #conta {
    .container {
      h2 {
        margin-bottom: 0;

        span {
          margin: 0;
          padding: 12px 0;
        }
      }

      button {
        width: 100%;
      }
    }
  }
}
</style>
